import styled from "styled-components";

export const Slide = styled.div`
  width: ${(props) => props.carouselWidth}px;
  height: auto;
  display: block;
`;
